(function(){
  'use strict';
  function nuke() {
    /* Anciens badges injectés par les versions précédentes */
    document.querySelectorAll('.dmx-img-badge-group, .dmx-pct-badge, [class*="dmx-pct-"]').forEach(function(el) {
      el.remove();
    });
  }
  [0, 50, 150, 300, 600, 1200].forEach(function(t) { setTimeout(nuke, t); });
  new MutationObserver(function() { nuke(); }).observe(document.body, { childList: true, subtree: true });
})();
